// frontend/app/components/lessonPlans/authoring/LessonAuthoringContext.js
//
// What the lesson wizard knows that a deeply nested asset picker needs: the
// board, the loaded curriculum tree, the authenticated fetch, and the lesson's
// own topic. Provided by LessonWizard; null anywhere else (e.g. the lesson
// toolkit shelf), in which case the picker only lists the catalogue it is given.
//
// Value: { board, curriculum, fetchWithAuth, lessonTopic: { board_topic_id,
//   source_topic_id, topic_name, level_id, subject_id, chapter_id },
//   browsedRows: { pwos, videos }, rememberRows(catalog) }
// `rememberRows` is how the picker hands over rows it fetched from another
// topic, so a cross-topic pick can be named in its field for the session.

import React, { useContext } from "react";

export const LessonAuthoringContext = React.createContext(null);

export const useLessonAuthoring = () => useContext(LessonAuthoringContext);
